module.exports = __webpack_public_path__ + "media/components/assets/vent_04-cf42494e4f5b4ce71f31d44ccaad4a03.jpg";